// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jLw2H","colBig":"styles_colBig__1rSTB","colSmall":"styles_colSmall__2zhlr"};